import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface ContactUSApiParameter {
    FirstName: string;
    LastName: string;
    Email: string;
    // Country: string;
    PhoneNumber: string;
    Extension: string;
    CompanyName: string;
    StreetAddress1: string;
    StreetAddress2: string;
    City: string;
    State: string;
    Zip: string;
    NumberOfRooms: string;
    ContactUs: boolean;
    TypeofCoffeeMachine: any;
}
export interface ContactUsResultModel {
    FirstName: string;
    LastName: string;
    Email: string;
    // Country: string;
    PhoneNumber: string;
    Extension: string;
    CompanyName: string;
    StreetAddress1: string;
    StreetAddress2: string;
    City: string;
    State: string;
    Zip: string;
    NumberOfRooms: string;
    ContactUs: boolean;
    TypeofCoffeeMachine: any;
}
export interface Properties {}

const autocompleteUrl = "api/v2/takeAwaymail";

const contactUS = "api/v1/ShipOrderSamples/OrderSamples";

export function ContactUsForm(
    parameter: ContactUSApiParameter & HasOnSuccess<ContactUsResultModel> & HasOnComplete<ContactUsResultModel>,
) {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    return post<ContactUsResultModel>(autocompleteUrl, apiParameter);
}

// export function contactusmail(parameter: ContactUSApiParameter & HasOnSuccess<ContactUsResultModel>) {
//     const ContactUsOptions = { ...parameter };
//     delete ContactUsOptions.onSuccess;
//     return post<ContactUsResultModel>(contactUS, ContactUsOptions);
// }
export function contactusmail(parameter: ContactUSApiParameter) {
    return post<ContactUSApiParameter, void>(`${contactUS}`, parameter);
}
